import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import { useSettingsContext } from "../../../components/settings";
import CustomBreadcrumbs from "../../../components/custom-breadcrumbs";
// sections
import EditClassSessionForm from "src/sections/@dashboard/class/EditClassSessionForm";

// ----------------------------------------------------------------------

export default function EditSession() {
  const { themeStretch } = useSettingsContext();

  return (
    <>
      <Helmet>
        <title> Session: Edit class session | Fahrschule Star</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : "lg"}>
        <CustomBreadcrumbs
          heading="Edit a class session"
          links={[
            {
              name: "Dashboard",
              href: PATH_DASHBOARD.root,
            },
            {
              name: "Sessions",
              href: PATH_DASHBOARD.classes.sessions,
            },
            { name: "Edit session" },
          ]}
        />
        <EditClassSessionForm />
      </Container>
    </>
  );
}
